/**
 * @module interface
 */
export interface V2TimGroupMemberInfo {
    userID?: string;
    nickName?: string;
    nameCard?: string;
    friendRemark?: string;
    faceUrl?: string;
}
